import React from 'react';
import { ViewSelectorProvider } from '../common/view-selector';
import styles from './fullscreen-layout.module.scss';

export function FullscreenLayout({ children }) {
  return (
    <ViewSelectorProvider>
      <div className={styles.root}>{children}</div>
    </ViewSelectorProvider>
  );
}
